/** Initials for an account avatar: first+last name initials, else the first
 * letter of the username. Display only — never used as an identity key. */
export const getUserInitials = (user) => {
	if (!user) return '';
	const firstName = user.firstName || '';
	const lastName = user.lastName || '';

	if (!firstName && !lastName) return user.username?.charAt(0)?.toUpperCase() || '';
	if (!lastName) return firstName.charAt(0).toUpperCase();
	if (!firstName) return lastName.charAt(0).toUpperCase();

	return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
};

/** Display name for an account row; falls back to the exact username. */
export const getAccountDisplayName = (user) => {
	const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');
	return name || user?.username || '';
};
